import {gsap} from 'gsap';

export const setTriPos = (tri: HTMLElement, triInner: HTMLElement, depth: number, maxAngle: number, origAngle: number) => {
  const curPos = tri.getBoundingClientRect().top;
  const baseHeight = tri.clientHeight;
  const dist = baseHeight + window.innerHeight;
  const progress = (curPos + baseHeight) / dist;
  const maxY = window.innerHeight * depth * 0.25;
  if (progress > 1.2 || progress < -0.2) return;
  const angle = origAngle + progress * maxAngle;
  const y = maxY * progress;
  gsap.set(triInner, {
    rotate: angle,
    y: y,
  });
};
